import LegalLayout from "@/components/LegalLayout";
import SEO from "@/components/SEO";

export default function Privacy() {
  return (
    <>
      <SEO
        title="Privacy Policy"
        description="How United Techlab collects, uses, and protects your personal information."
        path="/privacy"
      />
      <LegalLayout
        eyebrow="> /legal/privacy"
        title="Privacy Policy"
        lastUpdated="December 2025"
      >
        <p>
          United Techlab ("we", "us", "our") respects your privacy and is
          committed to protecting the personal data you share with us. This
          policy explains what we collect, how we use it, and your rights.
        </p>

        <h2>1. Information we collect</h2>
        <ul>
          <li>Contact information you provide via our contact form (name, email, company, message, service interest).</li>
          <li>Audit answers you provide via our Modernization Risk Audit.</li>
          <li>Limited technical data (IP address, browser, device info, pages visited) via standard analytics.</li>
          <li>Communication history when you correspond with us by email.</li>
        </ul>

        <h2>2. How we use your information</h2>
        <ul>
          <li>To respond to your enquiries and deliver the services you request.</li>
          <li>To generate your Modernization Risk Audit report.</li>
          <li>To operate, maintain and improve our website and products.</li>
          <li>To comply with legal obligations and protect our legitimate business interests.</li>
        </ul>

        <h2>3. Sharing of information</h2>
        <p>
          We do not sell your personal information. We may share data with
          vetted service providers (for example, email delivery via Resend,
          analytics, and cloud hosting) strictly for the purposes described
          above.
        </p>

        <h2>4. Data retention</h2>
        <p>
          We keep contact submissions and related communications for as long as
          necessary to serve you or meet legal requirements, and delete or
          anonymize them thereafter.
        </p>

        <h2>5. Your rights</h2>
        <ul>
          <li>Access, correct or delete the personal information we hold about you.</li>
          <li>Object to or restrict certain processing activities.</li>
          <li>Request a portable copy of your data.</li>
        </ul>

        <h2>6. Security</h2>
        <p>
          We apply industry-standard safeguards to protect your data. No system
          is 100% secure, but we take the integrity of your information
          seriously.
        </p>

        <h2>7. Contact</h2>
        <p>
          Questions about this policy? Email{" "}
          <a href="mailto:contact@unitedtechlab.com">contact@unitedtechlab.com</a>.
        </p>
      </LegalLayout>
    </>
  );
}
